var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusiveCollab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11161",
    "data-name": "Group 11161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4264",
    "data-name": "Rectangle 4264",
    width: 130,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11096",
    "data-name": "Group 11096",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44790",
    "data-name": "Path 44790",
    d: "M130,65A65,65,0,1,1,65,0a65,65,0,0,1,65,65",
    fill: "#ffcd05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44791",
    "data-name": "Path 44791",
    d: "M129.376,150.278c-1.152,1.726-3.879,2.269-4.39,4.483a42.865,42.865,0,0,0-.12,7.84c.289,2.505,2.451,1.9,4.12,1.193a8.228,8.228,0,0,0,4.667-5.8l5.88-.048c.876,1.51,2.635,4.349,4.262,5.066,2.042.9,4.576.253,6.651.5,2.962.355,12.479,9.05,16.007,10.488,2.349,2.235.176,6.351-3.09,4.945-4.691-2.758-9.135-7.133-13.767-9.815a1.858,1.858,0,0,0-1.913-.287l.03,1.512,11.176,7.764a2.688,2.688,0,0,1-3.016,4.339c-3.158-1.26-7.11-5.657-10.239-7.244-1.282-.65-2.506-.326-1.7,1.173,1.965,1.963,9.062,4.717,8.06,8.015-1.7,5.6-9.151-2.936-11.5-3.789-.933-.339-1.749.24-1.386,1.107.735,1.753,3.935,1.491,3.81,4.457-.091,2.147-2.36,2.829-4.1,1.946-1.564-.794-.719-2.4-1.018-3.751a4.262,4.262,0,0,0-3.654-2.84c-.108-.823.643-1.175.781-2,.743-4.441-3.782-7.306-7.272-4.363-1.3-2.623-3.751-4.083-6.6-2.663-1.528-2.231-2.459-3.113-5.327-2.9-.586.044-1.223.441-1.591.429-1.063-.033-3.572-3.682-4.061-4.751l10.692-15.013c1-.827,6.988.055,8.606,0",
    transform: "translate(-74.302 -101.199)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44792",
    "data-name": "Path 44792",
    d: "M161.3,161.381v-6.756c0-.236.812-1.088,1.054-1.331.722-.725,5.025-4.245,5.717-4.351,1.983-.3,5.074-.47,7.129-.555a111.572,111.572,0,0,1,17.439.864l10.744,15.219c.035.387-3.313,5.016-4.266,4.826l-12.57-8.654c-3.183-.507-6.129,1.1-8.547-1.521-1.458-1.578-1.849-4.127-4.115-4.363-1.044-.109-6.276-.141-6.87.282-.629.638-.546,1.68-.9,2.548a5.828,5.828,0,0,1-4.818,3.792",
    transform: "translate(-108.881 -100.117)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44793",
    "data-name": "Path 44793",
    d: "M70,145.931l14.3-16.567,7.938,5.042L79.408,152.249Z",
    transform: "translate(-47.25 -87.321)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44794",
    "data-name": "Path 44794",
    d: "M270,129.133l14.419,16.284-9.392,6.705-12.556-17.645Z",
    transform: "translate(-177.166 -87.165)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44795",
    "data-name": "Path 44795",
    d: "M161.175,230.406a2.607,2.607,0,0,1,.688,2.48,65.906,65.906,0,0,1-4.727,6.153,2.484,2.484,0,0,1-3.94-2.882c.123-.357,4.087-5.449,4.51-5.82a2.434,2.434,0,0,1,3.469.07",
    transform: "translate(-103.276 -155.01)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44796",
    "data-name": "Path 44796",
    d: "M139.874,224.413c1.6-.354,3.485.972,3.209,2.662a20.79,20.79,0,0,1-3.127,4.316c-2.015,1.671-4.507-.073-3.925-2.6.2-.878,2.958-4.179,3.844-4.375",
    transform: "translate(-91.762 -151.44)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44797",
    "data-name": "Path 44797",
    d: "M175.726,252.518c4.6,0,1.9,7.561-1.821,5.656-2.671-1.37-.56-5.656,1.821-5.656",
    transform: "translate(-116.546 -170.45)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44798",
    "data-name": "Path 44798",
    d: "M120.924,217.36c2.983-3.283,6.761,1.187,3.485,3.618-2.908,2.158-5.564-1.329-3.485-3.618",
    transform: "translate(-81.123 -145.934)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveCollab);
export default __webpack_public_path__ + "static/media/exclusive-collab.dd55902cb79fb3a43947e35a28d92ee3.svg";
export { ForwardRef as ReactComponent };